import React, { useState } from 'react'
import Navbar from '../components/Navbar'
import Sidebar from '../components/Sidebar'
import { Outlet, useLocation } from 'react-router-dom'
import './MainLayout.css'
import '../branding/brand.css'

function MainLayout() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const { pathname } = useLocation();
    const hideSidebar = pathname.startsWith('/admin-grafana');

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <>
            <Navbar onToggleSidebar={hideSidebar ? undefined : toggleSidebar} />
            <div className={`main-layout-container${hideSidebar ? ' sidebar-hidden' : ''}`}>
                {!hideSidebar && (
                    <Sidebar isOpen={isSidebarOpen} onToggleSidebar={toggleSidebar} />
                )}
                <div className={`main-content-area${hideSidebar ? ' full-width' : ''}`}>
                    <Outlet />
                </div>
            </div>
        </>
    )
}

export default MainLayout
